<template>
  <div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <p class="title is-4">
            Appointment Times - all times are {{ displayedTimezone }}
          </p>
        </div>
      </div>
    </div>
    <div v-if="suiteCount < 3" class="tabs is-medium">
      <ul>
        <li
          v-for="(key, idx) in sortedSuiteKeys"
          :key="idx"
          @click="activeSuiteKey = key"
          :class="activeSuiteKey === key ? 'is-active' : ''"
        >
          <a>
            {{ suites[key].name }}
          </a>
        </li>
      </ul>
    </div>
    <div v-else>
      <div class="select mb-4 ml-8">
        <select @change="activeSuiteKey = $event.target.value">
          <option
            v-for="(key, idx) in sortedSuiteKeys"
            :key="idx"
            :value="key"
            :selected="activeSuiteKey === key"
            :class="activeSuiteKey === key ? 'is-active' : ''"
          >
            {{ suites[key].name }}
          </option>
        </select>
      </div>
    </div>
    <schedule
      v-for="(suite, key) in suites"
      :key="key"
      v-if="activeSuiteKey === key"
      :id="id"
      :suiteId="key"
      :isSuiteWriteable="
        !!writeableSuites.filter(suite => suite === key).length
      "
    >
    </schedule>
  </div>
</template>

<script>
import dbhelpers from '@/services/dbhelpers';
import { mapGetters } from 'vuex';
import Schedule from './Schedule';
import { db } from '@/services/firebase';
import { convertMeetingTimezoneToShortName } from '@/services/utils';

export default {
  props: {
    id: { type: String }
  },
  data() {
    return {
      suites: {},
      activeSuiteKey: '',
      meeting: {}
    };
  },
  computed: {
    ...mapGetters(['user']),
    activeSuite() {
      return this.suites[this.activeSuiteKey] || {};
    },
    writeableSuites() {
      let userSuites = this.user.meetings[this.id].suites;
      return Object.keys(userSuites).filter(suiteId => userSuites[suiteId]);
    },
    sortedSuiteKeys() {
      return Object.keys(this.suites).sort((a, b) => {
        const suiteAName = this.suites[a].name ? this.suites[a].name : '';
        const suiteBName = this.suites[b].name ? this.suites[b].name : '';
        return suiteAName.localeCompare(suiteBName);
      });
    },
    suiteCount() {
      return Object.entries(this.suites).length;
    },
    displayedTimezone() {
      return convertMeetingTimezoneToShortName(
        this.meeting && this.meeting.timezone
          ? this.meeting.timezone
          : 'US/Eastern'
      );
    }
  },
  created() {
    let lowestSortedName = '';
    dbhelpers.getUserSuiteDocs(this.id).forEach(suiteDoc => {
      suiteDoc.onSnapshot(snap => {
        this.$set(this.suites, snap.id, { ...snap.data() });

        // pick active suite as the first name alphabetically
        if (lowestSortedName === '' || snap.data().name < lowestSortedName) {
          lowestSortedName = snap.data().name;
          this.activeSuiteKey = snap.id;
        }
      });
    });
  },
  components: {
    Schedule
  },
  firestore() {
    let meeting = db.collection('meetings').doc(this.id);
    return {
      meeting
    };
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/attendees/UserSuites.vue